import React from 'react';
import Head from 'next/head';

export interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  robots?: string;
  canonical?: string;
  linkedData?: Record<string, unknown>;
}
export const Seo = ({ title, description, keywords, robots, canonical, linkedData }: SeoProps) => (
  <Head>
    <title>{title}</title>
    <meta name="description" content={description} />
    {keywords && <meta name="keywords" content={keywords} />}
    {robots && <meta name="robots" content={robots} />}
    {canonical && <link rel="canonical" href={canonical} />}
    {linkedData && (
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(linkedData) }}
      />
    )}
  </Head>
);
